// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__1y0MC","Label":"Input_Label__zDOhQ","InputElement":"Input_InputElement__Q7xCn","Invalid":"Input_Invalid__jOOZr"};